<template>
    <transition name="fade">
        <ConfirmacaoModal v-if="cModal" @changeVisibility="cModal = false" @changeAndReload="closeCModal()" :loja="lojaConfirmacao" type="ativas"/>
    </transition>
    <transition name="fade">
        <PesquisadorModal v-if="pmodal" @changeVisibility="pmodal = false" @close="closePModal()" :cnpjs="cnpjs" type="ativas"/>
    </transition>
    <section id="lojas" ref="testeDiv" class="w-full px-8 m-auto py-8 h-full">
    <div class="w-full flex mb-4 justify-between">
        <p class="dark:text-gray-200 text-gray-700 text-2xl tracking-widest uppercase">Lojas ativas</p>
    </div>
    <div class="w-full flex mb-1 justify-between gap-x-4">
        <span class="text-gray-200 text-3xl uppercase w-1/4"> </span>
        <div class="flex-1 px-5 flex flex-row items-center gap-x-2" v-if="userRole === 'administrador'">
            <span @click="selectAll()"  :class="selected.length ? 'dark:text-indigo-400 text-indigo-600' : 'text-gray-500' " class="h-6 w-6 rounded-full transition-colors duration-300 select-none cursor-pointer">
                <span v-if="selected.length == 0" class="material-icons">
                    radio_button_unchecked
                </span>
                <span v-else class="material-icons-outlined">
                    check_circle
                </span>
            </span>
            <p class="dark:text-gray-200 text-gray-700">{{`${!selected.length ? 'Selecionar todos' : selected.length + ` loja${selected.length > 1 ? 's' : ''} selecionada${selected.length > 1 ? 's' : ''} —`}`}}</p>
            <button v-if="selected.length > 0" @click="configPModal()" class="text-indigo-600 dark:text-indigo-400">Alterar pesquisador para as lojas selecionadas</button>
        </div>
    </div>
    <div class="flex flex-row gap-x-4 w-full">
        <div class="pt-2 w-1/4 flex-none h-40 sticky rounded-lg">
            <div class="w-4/5 m-auto py-4 flex flex-col gap-y-4">
                <p class="text-2xl dark:text-gray-300 text-gray-700">Filtros</p>
                <Input label="CNPJ" type="text" v-debounce:300="filter" v-model="cnpjSearch" v-maska="'##.###.###/####-##'"/>
                <Input label="Razão Social" type="text" v-debounce:300="filter" v-model="razaoSearch"/>
                <Input label="Nome Fantasia" type="text" v-debounce:300="filter" v-model="nomeSearch"/>
                <span v-if="userRole === 'administrador'">
                    <br>
                    <Autocomplete label="Pesquisador" v-model="pesquisadorFilter" placeholder="Selecionar pesquisador" :list="listPesquisadores" @filter="filter()" desc="nome"/>
                </span>
                <br>
                <Select label="Segmento" placeholder="Selecionar segmento" :list="listSegmentos" v-model="segmentoSearch" @filter="filter()" desc="descricao"/>
                <Select label="Status" placeholder="Selecionar status" :list="listStatus" v-model="statusSearch" @filter="filter()" desc="descricao"/>
                <Select label="Região" placeholder="Selecionar região" :list="listRegioes" v-model="regiaoSearch" @filter="filter()" desc="descricao"/>
                <Select label="Faturamento" placeholder="Selecionar faturamento" :list="listFaturamentos" v-model="faturamentoSearch" @filter="filter()" desc="descricao"/>
                <div class="flex flex-col flex-wrap border-gray-300 dark:border-gray-600 border p-2 rounded-lg">
                    <p class="w-full text-gray-300 dark:text-gray-600 font-bold text-sm mb-2">Recolhas</p>
                    <span class="flex gap-x-4 items-center flex-wrap">
                        <input v-model.lazy="radio" type="radio" id="todos" name="drone" value="0" checked>
                        <label :class="radio === '0' ? 'text-indigo-500' : 'text-gray-400 dark:text-gray-600'" class="transition-all duration-300" for="todos">Todos</label>
                    </span>
                    <span class="flex gap-x-4 items-center flex-wrap">
                        <input v-model.lazy="radio" type="radio" id="com" name="drone" value="1">
                        <label :class="radio === '1' ? 'text-indigo-500' : 'text-gray-400 dark:text-gray-600'" class="transition-all duration-300" for="com">Mês corrente</label>
                    </span>
                    <span class="flex gap-x-4 items-center flex-wrap">
                        <input v-model.lazy="radio" type="radio" id="sem" name="drone" value="2">
                        <label :class="radio === '2' ? 'text-indigo-500' : 'text-gray-400 dark:text-gray-600'" class="transition-all duration-300" for="sem">Meses anteriores</label>
                    </span>
                </div>
            </div>
        </div>
        <div id="lojas-section" class="w-3/4 flex-none flex flex-col flex-wrap gap-y-4">
            <Skeleton v-if="loading" :pageSize="10"/>
            <div v-else-if="lojas.length == 0 && !loading" class="dark:text-gray-400 text-gray-500 dark:bg-gray-800 bg-gray-200 w-full h-24 rounded-lg flex flex-col items-center justify-center py-2 px-5">
                <p class="text-lg">Nenhum resultado encontrado para essa pesquisa</p>
            </div>
            <span v-for="loja in lojas" :key="`lojas-${loja.id}`" class="w-full">
                <div class=" dark:bg-gray-800 bg-gray-100 border border-gray-200 dark:border-gray-700 w-full h-50 rounded-lg">
                    <span class="flex flex-row py-2 gap-x-8 px-5">
                        <div class="flex items-center w-6" v-if="userRole === 'administrador'">
                            <div @click="select(loja.cnpj)" :class="selected.includes(loja.cnpj) ? 'dark:text-indigo-400 text-indigo-600' : 'text-gray-500' " class="h-6 w-6 rounded-full transition-colors duration-300 select-none cursor-pointer">
                                <span v-if="!selected.includes(loja.cnpj)" class="material-icons">
                                    radio_button_unchecked
                                </span>
                                <span v-else class="material-icons-outlined">
                                    check_circle
                                </span>
                            </div>
                        </div>
                        <div class="flex flex-col content-around h-full w-1/2">
                            <div><p class="text-sm text-gray-500 dark:text-gray-400 truncate">#{{loja.id}}</p></div>
                            <div><p class="text-lg dark:text-indigo-400 text-indigo-600 truncate">{{loja.razao_social}}</p></div>
                            <div><p class="text dark:text-indigo-200 text-indigo-500">{{loja.nome_fantasia}}</p></div>
                            <div><p class="text-sm dark:text-gray-200 text-gray-600">{{cnpjMask(loja.cnpj)}}</p></div>
                            <div><p class="text-sm dark:text-gray-200 text-gray-600 font-bold">{{loja.segmento}}</p></div>
                            <div><p :class="getStatusColor(loja.status.id)" class="text-sm font-bold">{{loja.status.descricao}}</p></div>
                            <div class="mt-2">
                                <p class="dark:text-gray-300 text-gray-500 text-sm">{{phoneMask(loja.telefone1) ? phoneMask(loja.telefone1) :  phoneMask(loja.telefone2) ? phoneMask(loja.telefone1) : 'Não há telefones cadastrados'}} - {{loja.nome_contato ? loja.nome_contato : 'Sem informação de contato'}}</p>
                                <p class="dark:text-gray-300 text-gray-500 text-sm">{{loja.email}}</p>
                            </div>
                            <div class="mt-4 flex flex-row items-center dark:text-gray-400 text-gray-500">
                                <span class="material-icons md-12">location_on</span>
                                <p class="uppercase text-xs break-words">{{loja.endereco.endereco}}, {{loja.endereco.numero}}, {{loja.endereco.bairro}} - {{loja.endereco.cidade}} - {{loja.endereco.estado}}</p>
                            </div>
                        </div>
                        <div class="w-1/4 justify-center self-center">
                            <div class="flex flex-col gap-y-2">
                                <div>
                                    <p class="text-center text-sm dark:text-gray-500 text-gray-600 uppercase">Última Recolha</p>
                                    <p class="text-center text dark:text-indigo-200 text-indigo-600">{{loja.ultima_recolha ? dateMask(loja.ultima_recolha) : 'Não há recolhas para essa loja'}}</p>
                                </div>
                                <div>
                                    <p class="text-center text-sm dark:text-gray-500 text-gray-600 uppercase">Região</p>
                                    <p class="text-center text dark:text-indigo-200 text-indigo-600">{{loja.endereco.regiao}}</p>
                                </div>
                                <div>
                                    <p class="text-center text-sm dark:text-gray-500 text-gray-600 uppercase">Faturamento</p>
                                    <p class="text-center text dark:text-indigo-200 text-indigo-600">{{loja.faturamento}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="w-1/5 justify-center self-center flex flex-col gap-y-2 items-center">
                            <p class="dark:text-gray-500 text-gray-600">PESQUISADOR</p>
                            <div v-if="loja.pesquisador" class="w-16 h-16 bg-indigo-300 rounded-full">
                                <img v-if="loja.pesquisador_avatar" class="rounded-full " :src="loja.pesquisador_avatar" alt="">
                                <span v-else class="h-full w-full flex text-gray-100"><p class="m-auto text-3xl">{{loja.pesquisador[0]}}{{loja.pesquisador.split(' ')[1][0]}}</p></span>
                            </div>
                            <span @click="configPModal(loja.cnpj)" v-else class="material-icons-outlined text-6xl text-indigo-400 dark:text-indigo-200  cursor-pointer">
                                person_add
                            </span>
                            <p class="dark:text-gray-200 text-gray-600 text-center">{{loja.pesquisador ? loja.pesquisador : 'Nenhum pesquisador selecionado'}}</p>
                        </div>
                        <div class="flex-1 flex flex-col gap-y-5 w-6 my-auto">
                            <span @click="openConfirmacao(loja.id)" class=" material-icons-outlined self-center text-3xl hover:text-indigo-400 text-gray-400 dark:text-gray-500 rounded-full transition-colors duration-300 select-none cursor-pointer">
                                content_paste
                            </span>
                            <span @click="click2dial(phoneMask(loja.telefone1), phoneMask(loja.telefone2), loja.id)" v-if="phoneMask(loja.telefone1) || phoneMask(loja.telefone2)" class="h-1/2 material-icons text-3xl hover:text-indigo-400 text-gray-400 dark:text-gray-500 rounded-full transition-colors duration-300 select-none cursor-pointer">
                                {{calling.status && calling.lojaId === loja.id ? 'phone_in_talk' : 'phone'}}
                            </span>
                            <span @click="router.push(`ativas/${loja.id}`)" class="h-1/2 material-icons-outlined text-3xl hover:text-indigo-400 text-gray-400 dark:text-gray-500 rounded-full transition-colors duration-300 select-none cursor-pointer">
                                info
                            </span>
                        </div>
                    </span>
                </div>
            </span>
        </div>
    </div>
    <div class="w-full flex mb-1 justify-between gap-x-4">
        <p class="text-gray-200 text-3xl uppercase w-1/4"> </p>
        <div class="flex-1 px-5 flex flex-row items-center gap-x-2">
            <Paginator :data="paginationData" type="page" @changePage="changePage" @changePageSize="changePageSize"/>
        </div>
    </div>
  </section>
</template>
<script>
import { GET_REGIOES, GET_FATURAMENTOS, GET_SEGMENTOS, GET_LOJAS_ATIVAS_FILTER, GET_LOJAS_ATIVAS, GET_STATUS_CONTATO_ATIVAS, REQUEST_CALL, GET_PESQUISADORES_ADMIN } from '../../mixins/api.js'
import { telephoneMask, cnpjMask as cnpj_mask, dateTimeFormat } from '../../mixins/mask.js'
import { onMounted, reactive, ref, watch } from 'vue'
import axios from 'axios'
import PesquisadorModal from './PesquisadorModal.vue'
import ConfirmacaoModal from './ConfirmacaoModal.vue'
import Input from '@/components/Design/Input'
import Autocomplete from '@/components/Design/Autocomplete'
import Select from '@/components/Design/Select'
import Paginator from '@/components/Design/Pagination'
import Skeleton from './LojaSkeleton.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getStatusColor as getColor } from '../../mixins/colors'
import { displayNotification } from '../../mixins/notification.js'
export default {
    name: 'Lojas',
    components: {
        Input,
        Skeleton,
        Paginator,
        Select,
        PesquisadorModal,
        ConfirmacaoModal,
        Autocomplete
    },
    setup () {
        const phoneMask = telephoneMask
        const cnpjMask = cnpj_mask
        const dateMask = dateTimeFormat
        const store = useStore()
        const router = useRouter()
        const radio = ref('')

        const userRole = store.getters['auth/user'].role

        // Select items
        const selected = ref([])
        const select = (cnpj) => {
            if (selected.value.includes(cnpj)) {
                var index = selected.value.indexOf(cnpj)
                if (index !== -1) {
                    selected.value.splice(index, 1)
                }
            } else {
                selected.value.push(cnpj)
            }
        }
        const selectAll = () => {
            if (selected.value.length != lojas.value.length) {
                for (const l in lojas.value) {
                    if (!selected.value.includes(lojas.value[l].cnpj)) { selected.value.push(lojas.value[l].cnpj) }
                }
            } else {
                while (selected.value.length > 0) {
                    selected.value.pop()
                }
            }
        }

        const lojas = ref([])
        const loading = ref(true)
        onMounted(async () => {
            await GET_LOJAS_ATIVAS(10).then(response => {
                persistFilter.value = response.config.url
                lojas.value = response.data.data
                loading.value = false
                paginationData.value = response.data.meta
            }).catch(() => {
            })
        })

        const paginationData = ref({})
        const paginationRequest = async (url) => {
            loading.value = true
            await axios.get(url).then(response => {
                lojas.value = response.data.data
                loading.value = false
                paginationData.value = response.data.meta
            })
            var element = document.getElementById('lojas-section')
            var top = element.offsetTop
            window.scrollTo(0, top)
        }

        const listSegmentos = ref([])
        const listStatus = ref([])
        const listRegioes = ref([])
        const listFaturamentos = ref([])
        const listPesquisadores = ref([])
        const getLists = async () => {
            await GET_STATUS_CONTATO_ATIVAS().then(r => {
                listStatus.value = r.data
                if (userRole.toLowerCase() !== 'administrador') {
                    listStatus.value = listStatus.value.filter(s => s.descricao.toLowerCase() !== 'loja cancelada pelo responsável')
                }
                listStatus.value = listStatus.value.filter(s => s.descricao.toLowerCase() !== 'mudança segmento')
            })
            await GET_REGIOES().then(r => {
                listRegioes.value = r.data
            })
            await GET_FATURAMENTOS().then(r => {
                listFaturamentos.value = r.data
            })
            await GET_SEGMENTOS().then(r => {
                listSegmentos.value = r.data
            })

            await GET_PESQUISADORES_ADMIN().then(response => {
                listPesquisadores.value = response.data
            })
        }
        getLists()

        const cnpjSearch = ref('')
        const razaoSearch = ref('')
        const nomeSearch = ref('')
        const segmentoSearch = ref('')
        const statusSearch = ref('')
        const regiaoSearch = ref('')
        const faturamentoSearch = ref('')
        const pesquisadorFilter = ref('')

        const persistFilter = ref('')
        const pageSize = ref(10)
        const filter = async (_, e, page) => {
            console.log('alo')
            const filters = {
                cnpj: cnpjSearch.value.replaceAll('.', '').replaceAll('/', '').replaceAll('-', ''),
                razao: razaoSearch.value,
                nome: nomeSearch.value,
                segmento: segmentoSearch.value ? listSegmentos.value.filter(x => x.descricao === segmentoSearch.value)[0].id : '',
                status: statusSearch.value ? listStatus.value.filter(x => x.descricao === statusSearch.value)[0].id : '',
                regiao: regiaoSearch.value ? listRegioes.value.filter(x => x.descricao === regiaoSearch.value)[0].id : '',
                faturamento: faturamentoSearch.value ? listFaturamentos.value.filter(x => x.descricao === faturamentoSearch.value)[0].id : '',
                page: page,
                corrente: radio.value,
                pesquisador_id: pesquisadorFilter.value ? listPesquisadores.value.filter(x => x.nome === pesquisadorFilter.value)[0].id : ''
            }
            await GET_LOJAS_ATIVAS_FILTER(pageSize.value, filters).then(response => {
                persistFilter.value = response.config.url
                lojas.value = response.data.data
                loading.value = false
                paginationData.value = response.data.meta
            }).catch(() => {
            })
        }

        watch(radio, () => {
            filter()
        })

        const changePage = (page) => {
            filter(null, null, page)
            scrollTop()
        }

        const changePageSize = (size) => {
            pageSize.value = size
            filter()
        }

        const testeDiv = ref(null)

        const modal = ref(false)
        const showModal = () => {
            modal.value = false
        }
        const pmodal = ref(false)
        const cnpjs = ref([])
        const configPModal = (cnpj) => {
            if (cnpj) {
                cnpjs.value = [cnpj]
            } else {
                cnpjs.value = selected.value
            }
            pmodal.value = true
        }

        const closeCModal = () => {
            cModal.value = false
            filter(null, null, paginationData.value.current_page)
        }

        const closePModal = () => {
            cnpjs.value = []
            selected.value = []
            pmodal.value = false
            filter(null, null, paginationData.value.current_page)
        }

        const lojaConfirmacao = ref({})
        const cModal = ref(false)
        const openConfirmacao = (id) => { // rever
            cModal.value = true
            lojaConfirmacao.value = lojas.value.filter(x => x.id === id)[0]
        }

        const create = ref(false)

        const redirectNew = () => {
            router.push('/dashboard/lojas/nova')
        }

        const scrollTop = () => {
            var element = document.getElementById('screen')
            element.scrollTo({ top: 0, behavior: 'smooth' })
        }

        const hover = ref('')
        const mouseOver = (v) => {
            hover.value = v
        }
        const pushToProducts = (id) => {
            router.push({ name: 'ProdutosLoja', params: { id: id.toString() } })
        }
        const pushToRecolha = (id) => {
            router.push({ name: 'ProcurarRecolha', params: { id: id.toString() } })
        }

        const getStatusColor = getColor

        const calling = reactive({
            lojaId: 0,
            status: false
        })
        const click2dial = async (phone1, phone2, lojaId) => {
            if (calling.status) {
                return
            }
            calling.lojaId = lojaId
            calling.status = true

            let callingPhone = ''
            if (phone1) {
                callingPhone = phone1.replace('(', '').replace(')', '').replace('-', '').replaceAll(' ', '')
            } else if (phone2) {
                callingPhone = phone2.replace('(', '').replace(')', '').replace('-', '').replaceAll(' ', '')
            }
            await REQUEST_CALL(callingPhone).then(r => {
                displayNotification(r)
            }).catch(e => {
                displayNotification(e.response)
            }).finally(() => {
                calling.status = false
            })
            openConfirmacao(lojaId)
        }

        return {
            lojas,
            selected,
            loading,
            paginationData,
            testeDiv,
            userRole,

            cnpjSearch,
            razaoSearch,
            nomeSearch,
            segmentoSearch,
            statusSearch,
            regiaoSearch,
            faturamentoSearch,
            pesquisadorFilter,
            listSegmentos,
            listStatus,
            listRegioes,
            listFaturamentos,
            listPesquisadores,

            create,

            persistFilter,

            lojaConfirmacao,
            cModal,
            modal,
            pmodal,
            cnpjs,
            radio,

            // Functions
            showModal,
            paginationRequest,
            select,
            selectAll,
            phoneMask,
            cnpjMask,
            dateMask,
            filter,
            configPModal,
            closePModal,
            closeCModal,
            openConfirmacao,
            redirectNew,
            changePage,
            changePageSize,
            scrollTop,
            mouseOver,
            pushToProducts,
            pushToRecolha,
            getStatusColor,
            click2dial,
            router,
            hover,
            calling

        }
    }
}
</script>

<style scoped>

.transition-enter-from {
  opacity: 0;
  transform: translateX(-10%);
}
.transition-enter-to {
  opacity: 1;
  transform: translateX(0%);
}

.transition-enter-active {
  transition: all 0.3s ease-in-out;
}

.transition-leave-active {
  transition: all 0.3s ease-in-out;
}

.transition-leave-from {
  opacity: 1;
  transform: translateX(0%);
}

.transition-leave-to {
  opacity: 0;
  transform: translateX(-10%);
}

</style>
